// src/services/demoApi/demoStorage.ts
// Слой демо-персистентности: все демо-фичи хранят состояние в localStorage
// под ключами demo_*, чтобы действия на демо переживали перезагрузку страницы.

/** Имитация сетевой задержки, чтобы демо-API выглядел как настоящий */
export const demoDelay = (ms = 400): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export function readDemoStore<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeDemoStore<T>(key: string, value: T): void {
  localStorage.setItem(key, JSON.stringify(value));
}
